// extracted by mini-css-extract-plugin
export default {"formGroup":"Input_formGroup__6gnOd","mandatory":"Input_mandatory__ZgNJs"};